import type { ReactNode } from "react";
import { ICON } from "./buttons";
import { SAFE_RIGHT, SAFE_TOP } from "./Hud";

/**
 * One row of icon buttons, top right: any `children` first (the quick
 * settings, #117), then pause (hidden while paused), controls, fullscreen.
 * `folded` (riding the hill on a phone, #198) leaves only Pause, out of the
 * road's way; the pause menu has the rest.
 */
export function TopButtons({
  children,
  touch,
  paused,
  onPause,
  onToggleHelp,
  fullscreen = false,
  onFullscreen,
  folded = false,
}: {
  children?: ReactNode;
  touch: boolean;
  paused: boolean;
  onPause: () => void;
  onToggleHelp: () => void;
  fullscreen?: boolean;
  onFullscreen: () => void;
  folded?: boolean;
}) {
  const controls = touch ? "Controls" : "Controls (H / Select)";
  const screen = fullscreen ? "Exit fullscreen" : "Fullscreen";
  return (
    <div className={`pointer-events-none absolute ${SAFE_RIGHT} ${SAFE_TOP} flex gap-2`}>
      {!folded && children}
      {!paused && (
        <button type="button" aria-label="Pause" title="Pause" onClick={onPause} className={ICON}>
          ❚❚
        </button>
      )}
      {!folded && (
        <>
          <button type="button" aria-label={controls} title={controls} onClick={onToggleHelp} data-controls-toggle className={ICON}>
            ?
          </button>
          <button type="button" aria-label={screen} title={screen} onClick={onFullscreen} className={ICON}>
            <FullscreenIcon exit={fullscreen} />
          </button>
        </>
      )}
    </div>
  );
}

/** Four corners pointing out (go fullscreen) or in (leave it). */
function FullscreenIcon({ exit }: { exit: boolean }) {
  const d = exit
    ? "M9 4v5H4 M15 4v5h5 M9 20v-5H4 M15 20v-5h5"
    : "M4 9V4h5 M20 9V4h-5 M4 15v5h5 M20 15v5h-5";
  return (
    <svg aria-hidden viewBox="0 0 24 24" className="size-5" fill="none" stroke="currentColor" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" data-icon={exit ? "exit" : "enter"}>
      <path d={d} />
    </svg>
  );
}
